import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '快速导航',
      items: [
        { label: '平台介绍', path: '/category/platform-intro' },
        { label: '使用教程', path: '/category/usage-guide' },
        { label: '账号安全', path: '/category/account-security' },
        { label: '最新动态', path: '/category/latest-news' },
      ],
    },
    {
      title: '帮助支持',
      items: [
        { label: '常见问题', path: '/category/faq-help' },
        { label: '社区交流', path: '/category/community' },
        { label: '关于我们', path: '/about' },
        { label: '联系客服', path: '/about#contact' },
      ],
    },
    {
      title: '热门文章',
      items: [
        { label: '91com最新入口', path: '/article/91com-official-website-latest-entry' },
        { label: '注册登录教程', path: '/article/91com-registration-login-tutorial' },
        { label: '账号安全指南', path: '/article/91com-account-security-guide' },
        { label: '新手快速入门', path: '/article/91com-beginner-quick-start' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-heading font-bold text-primary-400">
                91com
              </span>
              <span className="text-sm text-background-300 ml-2">官方平台</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3">
              <a
                href={`mailto:${siteInfo.email}`}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="邮箱"
              >
                <i className="ri-mail-line text-background-200"></i>
              </a>
              <a
                href={`tel:${siteInfo.phone}`}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="电话"
              >
                <i className="ri-phone-line text-background-200"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} {siteInfo.name} 版权所有 | {siteInfo.address}
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#" className="hover:text-background-200 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="hover:text-background-200 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="hover:text-background-200 transition-colors cursor-pointer">
              网站地图
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}